import React, { FunctionComponent } from 'react'

import { LinearGradient } from 'expo-linear-gradient'
import styled, { useTheme } from 'styled-components/native'

import { ThemeType } from '../../utils/themes/ThemeProvider'

const LinearGradientStyled = styled(LinearGradient)({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  opacity: 0.7,
})

export const GradientHeader: FunctionComponent = () => {
  const { colors } = useTheme() as ThemeType

  return (
    <LinearGradientStyled
      colors={[colors.gradientWebHeaderStart, colors.gradientWebHeaderEnd]}
      start={[0, 0]}
      end={[1, 1]}
      locations={[0, 1]}
      style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, opacity: 0.7 }}
    />
  )
}
